import React from 'react'

function ImageDefault({imageUrl='/images/default-chat.png',Width=100,Height=100,className='rounded-circle assist-img img-fluid',Alt='assistant'}) {
  return <img
  src={imageUrl ||'/images/default-chat.png'}
  width={Width}
  height={Height}
  className={className}
  alt={Alt}
  onError={(e) => e.target.src ='/images/default-chat.png'}
/>
}

export default ImageDefault